var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTailspin = function SvgTailspin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-2 -2 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    }
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "8.042%",
    y1: "0%",
    x2: "65.682%",
    y2: "23.865%",
    id: "tailspin_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor",
    stopOpacity: 0.631,
    offset: "63.146%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 18c0-9.94-8.06-18-18-18",
    stroke: "url(#tailspin_svg__a)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 36,
    cy: 18,
    r: 1
  }))));
};

export default SvgTailspin;